import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/deployment/bundle-withdraw-harvest.md?raw';

const DeploymentBundleWithdrawHarvest: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default DeploymentBundleWithdrawHarvest;
